module.exports = __webpack_public_path__ + "static/img/pice1.2812417.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/pice1.png
// module id = IwXp
// module chunks = 0